import { render, staticRenderFns } from "./BannedDialog.vue?vue&type=template&id=2b44a7e3&scoped=true"
import script from "./BannedDialog.vue?vue&type=script&lang=js"
export * from "./BannedDialog.vue?vue&type=script&lang=js"
import style0 from "./BannedDialog.vue?vue&type=style&index=0&id=2b44a7e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b44a7e3",
  null
  
)

export default component.exports